import { Outlet } from 'react-router-dom';

import { AccessDenied } from '@/pages/AccessDenied';

interface Props {
    roles: Array<string>;
}

export const RoleRoute: React.FC<Props> = ({ roles }) => {
    const user = { role: 'Admin' };

    const userHasRequiredRole = user && roles.includes(user.role) ? true : false;

    if (userHasRequiredRole) {
        return <Outlet />;
    }

    if (!userHasRequiredRole) {
        return <AccessDenied />;
    }

    return <AccessDenied />;
};
